"use client";

import React, { useState, useEffect } from "react";


const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Courses", href: "#courses" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = () => setMobileOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "nav-blur shadow-lg" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" className="flex items-center gap-3 group" aria-label="Hi-Hats Rajanukunte Home">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center font-display font-black text-lg"
            style={{
              background: "#F2C94C",
              color: "#111111",
              boxShadow: "0 0 20px rgba(242,201,76,0.3)",
            }}
          >
            HH
          </div>
          <div className="hidden sm:block">
            <p className="font-display font-black text-base leading-none text-white">Hi-Hats</p>
            <p className="text-xs leading-none mt-0.5" style={{ color: "rgba(255,255,255,0.4)" }}>
              Rajanukunte
            </p>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-display font-semibold transition-all duration-200"
              style={{ color: "rgba(255,255,255,0.6)" }}
              onMouseEnter={(e) => {
                (e.target as HTMLAnchorElement).style.color = "#F2C94C";
              }}
              onMouseLeave={(e) => {
                (e.target as HTMLAnchorElement).style.color = "rgba(255,255,255,0.6)";
              }}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:+919849007187"
            className="text-xs font-display font-semibold transition-colors"
            style={{ color: "rgba(255,255,255,0.4)" }}
            onMouseEnter={(e) => ((e.target as HTMLElement).style.color = "#29ABE2")}
            onMouseLeave={(e) => ((e.target as HTMLElement).style.color = "rgba(255,255,255,0.4)")}
          >
            +91 98490 07187
          </a>
          <a
            href="#enroll"
            className="btn-yellow px-6 py-2.5 rounded-lg text-sm font-display font-black"
          >
            Join the Jam
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileOpen}
        >
          <span
            className="block w-6 h-0.5 transition-all duration-300"
            style={{
              background: "#F2C94C",
              transform: mobileOpen ? "rotate(45deg) translate(4px, 4px)" : "none",
            }}
          />
          <span
            className="block w-6 h-0.5 transition-all duration-300"
            style={{
              background: "#F2C94C",
              opacity: mobileOpen ? 0 : 1,
            }}
          />
          <span
            className="block w-6 h-0.5 transition-all duration-300"
            style={{
              background: "#F2C94C",
              transform: mobileOpen ? "rotate(-45deg) translate(4px, -4px)" : "none",
            }}
          />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className="md:hidden mobile-menu"
        style={{
          maxHeight: mobileOpen ? "400px" : "0",
          opacity: mobileOpen ? 1 : 0,
          background: "rgba(17,17,17,0.98)",
          borderTop: "1px solid rgba(242,201,76,0.15)",
        }}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={handleNavClick}
              className="text-base font-display font-semibold py-2 border-b transition-colors"
              style={{
                color: "rgba(255,255,255,0.7)",
                borderColor: "rgba(255,255,255,0.06)",
              }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#enroll"
            onClick={handleNavClick}
            className="btn-yellow mt-2 px-6 py-4 rounded-xl text-base font-display font-black text-center"
          >
            🎵 Join the Jam
          </a>
        </div>
      </div>
    </header>
  );
}